import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from './AllListItem.module.scss';

interface AllListItemProps<T> {
    label?: string;
    icon?: IconDefinition;
    className?: string;
    onClick?: () => void;
}

export const AllListItem = <T,>(props: AllListItemProps<T>) => {
    return (
        <div
            className={clsx(styles.container, props.className)}
            onClick={props.onClick}
        >
            {props.icon && (
                <FontAwesomeIcon
                    icon={props.icon}
                    className={styles.icon}
                    fontSize={20}
                />
            )}
            <span className={styles.name}>{props.label ?? 'Select All'}</span>
        </div>
    );
};

export default AllListItem;
